import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from "../../config/ApiConstants";

export function activityAPI_Action(token, groupId, data) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/me/activity`,
      method: "GET",
      headers: {
        ...AUTH_HEADERS,
        Authorization: "Bearer " + token,
        groupId: groupId
      },
      body: "",
      types: [
        types.ACTIVITY_REQUEST,
        types.ACTIVITY_RECEIVE,
        {
          type: types.ACTIVITY_FAILURE,
          meta: (action, state, res) => {
            return action, state, res;
          },
        },
      ],
    },
  };
}

export const resetactivityAPI_Action = () => {
  return {
    type: types.RESET_ACTIVITY,
    payload: null,
  };
};
